<template>
  <div
    class="payment-mask"
    @click="closePaymentSuccessDlg"
  >
    <div class="payment-dialog" @click.stop>
      <el-button
        size="large"
        class="close-btn"
        link
        @click="closePaymentSuccessDlg"
      >×</el-button>
      <div class="dialog-content">
        <!-- 弹窗顶部 -->
        <div class="dialog-title">
          <div class="image-container">
            <div><img
              src="/static/images/payment_success_icon.png"
              class="success-icon"
            ></div>
            <div class="success-text">{{ $t('views.account_center.payment_success') }}</div>
          </div>
        </div>
        <!-- 弹窗中部 - 扩展包类型 -->
        <div
          v-if="orderType === 2"
          class="dialog-module"
        >
          <h2 class="module-title">{{ $t('views.account_center.thank_you') }}</h2>
          <p class="module-subtitle">
            <el-text type="success">{{ $t('views.account_center.payment_success') }}</el-text>
          </p>
          <div class="expand-package-info">
            <div class="package-header">
              <h3 class="package-name">{{ expandData.package_name }}</h3>
            </div>
            <div class="package-body">
              <el-text class="package-description">{{ expandData.description }}</el-text>
            </div>
          </div>
        </div>
        <!-- 弹窗中部 - 版本订阅类型 -->
        <div
          v-else
          class="dialog-module"
        >
          <h2 class="module-title">{{ $t('views.account_center.thank_you') }}</h2>
          <p class="module-subtitle"><el-text>{{ $t('views.account_center.upgrade_success', { verName }) }}<el-text /></el-text></p>
        </div>
        <!-- 弹窗尾部 - 版本订阅类型显示特权列表 -->
        <div
          v-if="orderType !== 2"
          class="list-module"
        >
          <h3 class="feature-title">{{ $t('views.account_center.privilege_activated', { verName }) }}</h3>
          <ul class="feature-list">
            <li
              v-for="(feature, index) in benefitsList"
              :key="index"
            >
              <img
                src="/static/images/green_Frame.png"
                class="feature-icon"
              ><el-text>{{ feature }}</el-text>
            </li>
          </ul>
        </div>
        <!-- 底部按钮 -->
        <div class="dialog-footer">
          <el-button
            size="small"
            type="primary"
            @click="closePaymentSuccessDlg"
          >{{ $t('views.account_center.try_now') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    verName: {
      type: String,
      default: ''
    },
    benefitsList: {
      type: Array,
      default: () => []
    },
    needReload: {
      type: Boolean,
      default: false
    },
    orderType: {
      type: Number,
      default: 1
    },
    expandData: {
      type: Object,
      default: () => ({
        package_name: '',
        description: ''
      })
    }
  },
  emits: ['closePaymentSuccessDlg'],
  mounted() {
    this.reloadPage()
  },
  methods: {
    closePaymentSuccessDlg() {
      this.$emit('closePaymentSuccessDlg')
    },
    reloadPage() {
      if (this.needReload) {
        setTimeout(() => window.location.reload(), 3000)
      }
    }
  }
}
</script>
<style scoped lang="scss">
@use '@/views/mobile/account_center/styles/payment_dialogs' as mobileDialogs;
@import '@/assets/css/views/account_center/components/payment_success';
@include mobileDialogs.success;
</style>
